import { atom, Getter } from 'jotai';

type ItemDescriptionData = {
  materialId: string;
  productDescriptionId: string;
  productDescriptionName: string;
};

// TODO: Replace this mock with actual productDescriptions query when available in backend
// Mock implementation that returns an empty array
export const itemDescriptionsQueryAtom = (
  _p0: (get: Getter) => {
    variables: { materialIds: string[] };
    skip: boolean;
  },
) =>
  atom({
    data: [] as ItemDescriptionData[],
    isLoading: false,
    isError: false,
    error: null,
    refetch: async () => ({ data: [] }),
    fetch: async () => [],
  });
